import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-text-section").forEach((el) => {
	initOnScrollAnimation(el);
});
